
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/home_styles.css';
import backgroundImage from '../assets/background.png';

const Home = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
            // 在桌面版預設展開，手機版預設收起
            setSidebarExpanded(width > 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: !isMobile && sidebarExpanded ? '250px' : '0'
                }}
            >
                <div className="container">
                <header 
                    className="header"
                    style={{
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '50% 60%', // 
                        backgroundRepeat: 'no-repeat'
                        }}
                >
                        <h1 className="title">行動計算研討會暨 無線、隨意及感測網路研討會</h1>
                        <h2 className="subtitle">2025年08月25-26日 @ 集思台大會議中心</h2>
                        <p className="highlight-text">邁向自主智慧的前瞻行動通訊與感知技術</p>
                    </header>

                    <div className={`content-wrapper ${isMobile ? 'content-wrapper-mobile' : ''}`}>
                        <section className="section">
                            <h2 className="subtitle">公告事項</h2>
                            <ul className="list">
                                <li className="list-item">(2025/03/19) 研討會網站成立</li>
                                <li className="list-item">(2025/04/30) 投稿系統上線</li>
                                <li className="list-item">(2025/04/30) <a href="https://drive.google.com/file/d/1ZsKR6yNjg3U0nO-WKzjj5eYrGW6iJ7wK/view?usp=sharing" target="_blank" rel="noreferrer" className="link" style={{ textDecoration: 'underline' }}>CFP連結</a></li>
                                <li className="list-item">
                                (2025/05/20) 研討會徵求贊助廠商 (
                                <Link to="./sponsorship" className="link" style={{ textDecoration: 'underline' }}>
                                    廠商贊助辦法
                                </Link>
                                )
                                </li>
                                <li className="list-item">
                                (2025/06/13) 投稿網址請見連結(
                                <Link to="./mc-submission" className="link" style={{ textDecoration: 'underline' }}>
                                    MC2025
                                </Link>
                                )、
                                (
                                <Link to="./wasn-submission" className="link" style={{ textDecoration: 'underline' }}>
                                    WASN2025
                                </Link>
                                )，歡迎踴躍投稿
                                </li>
                                <li className="list-item">
                                (2025/06/13) 議程表更新，詳情請見連結(
                                <Link to="./agenda" className="link" style={{ textDecoration: 'underline' }}>
                                    大會議程
                                </Link>
                                )
                                </li>
                                <li className="list-item">
                                (2025/06/13) 專題演講、跨域論壇更新，詳情請見連結(
                                <Link to="./speech" className="link" style={{ textDecoration: 'underline' }}>
                                    專題演講
                                </Link>
                                )、
                                (
                                <Link to="./discussion" className="link" style={{ textDecoration: 'underline' }}>
                                    跨域論壇
                                </Link>
                                )
                                </li>
                                <li className="list-item">
                                (2025/07/26) 大會註冊已開放，詳情請見連結(
                                <Link to="./registration" className="link" style={{ textDecoration: 'underline' }}>
                                    大會註冊
                                </Link>
                                )
                                </li>
                                <li className="list-item">(2025/07/31) 論文海報格式請見檔案<a href="https://docs.google.com/presentation/d/1jqVqlsueIKb_CXccgDHq-d5hp8hd9SVQ/edit?usp=sharing&ouid=115724323665868431051&rtpof=true&sd=true" target="_blank" rel="noreferrer" className="link" style={{ textDecoration: 'underline' }}>pptx</a></li>
                                <li className="list-item">
                                (2025/08/10) MC最佳論文、WASN最佳論文更新，詳情請見連結(
                                <Link to="./mc-best-paper" className="link" style={{ textDecoration: 'underline' }}>
                                    MC 最佳論文
                                </Link>
                                )、
                                (
                                <Link to="./wasn-best-paper" className="link" style={{ textDecoration: 'underline' }}>
                                    WASN 最佳論文
                                </Link>
                                )
                                </li>
                                <li className="list-item">
                                (2025/08/14) 國科會成果展海報版號碼公佈，詳情請見連結(
                                <Link to="./achievement" className="link" style={{ textDecoration: 'underline' }}>
                                    國科會成果展
                                </Link>
                                )
                                </li>
                                <li className="list-item">(2025/08/15) eDM請見檔案<a href="https://drive.google.com/file/d/1Ccv4TxfM1FKOYGoFfByYqQZ68h6MMAtj/view?usp=sharing" target="_blank" rel="noreferrer" className="link" style={{ textDecoration: 'underline' }}>pdf</a></li>
                                <li className="list-item">
                                (2025/08/15) MC海報編號、WASN海報編號，詳情請見連結(
                                <Link to="./mc-poster" className="link" style={{ textDecoration: 'underline' }}>
                                    MC 海報編號
                                </Link>
                                )、
                                (
                                <Link to="./wasn-poster" className="link" style={{ textDecoration: 'underline' }}>
                                    WASN 海報編號
                                </Link>
                                )
                                </li>
                            </ul>
                        </section>

                        <section className="section">
                            <h2 className="subtitle">重要日期</h2>
                            <ul className="list">
                            <li className="list-item important-date-item">
                                <span>論文投稿截止:</span>
                                <div>
                                    <div>2025年07月04日(Fri) Firm deadline</div>
                                    <div style={{ textDecoration: 'line-through' }}>
                                        2025年06月27日(Fri)
                                    </div>
                                    <div style={{ textDecoration: 'line-through' }}>
                                        2025年06月13日(Fri)
                                    </div>
                                    <div style={{ textDecoration: 'line-through' }}>
                                        2025年06月06日(Fri)
                                    </div>
                                </div>
                            </li>
                                <li className="list-item">審查結果通知: 2025年07月25日 (Fri)</li>
                                <li className="list-item">完稿上傳截止: 2025年08月01日 (Fri)</li>
                                <li className="list-item">論文註冊截止: 2025年08月08日 (Fri)</li>
                            </ul>
                        </section>
                    </div>

                    <section className="section">
                        <h2 className="subtitle">關於MC 2025</h2>
                        <p>
                        隨著行動通訊技術（5G/6G）的迅速發展，行動計算（Mobile Computing, MC） 已成為現代科技與產業創新的關鍵領域。
                        MC 2025 國際會議匯聚全球學術與產業專家，共同探討行動計算的最新進展、挑戰與未來趨勢。本屆會議將涵蓋行動計算與通訊技術的核心議題，並關注其與人工智慧（AI）、大數據、物聯網（IoT）等前沿技術的深度融合。
                        在 5G/6G 網路的驅動下，行動計算的應用場景正持續拓展，不僅促進高效、靈活的計算能力與資訊存取，亦推動智慧型應用的快速發展。
                        本次會議將探討的議題包括行動網路連通性、物聯網架構、雲端與邊緣運算協作、行動安全與隱私保護，以及智慧應用技術，例如群眾外包、自動駕駛、社群網絡分析等。透過本次會議，與會者將深入了解行動計算的技術挑戰與未來機遇，並共同推動該領域的創新發展。
                        MC 2025 不僅提供最前沿的學術研究交流機會，也致力於促進產業界與學術界的合作，共同探索行動計算技術如何塑造未來數位生活。
                        透過本次國際會議，我們期望推動更智慧、更高效、更安全的行動計算生態，邁向數位化、智能化的未來社會。
                        </p>
                    </section>

                    <section className="section">
                        <h2 className="subtitle">關於WASN 2025</h2>
                        <p>
                        隨著無線通訊技術的持續演進，無線、隨意及感測網路（Wireless, Ad-hoc, and Sensor Networks, WASN） 在科技領域中發揮著日益重要的作用。
                        此類網路技術的發展，不僅推動了物聯網（IoT）與智慧感測技術的廣泛應用，亦促成了諸多創新場景的實現，如智慧城市、智慧醫療、精準農業、環境監測及工業自動化等。
                        這些技術進步為數位化轉型注入了新的動能，推動社會邁向更智慧化、高效能的未來。
                        WASN 具有高度的靈活性與擴展性，能夠實現對環境、物理對象及各類數據的即時感知、收集與傳輸，進一步提升智慧應用的深度與廣度。
                        然而，隨著無線感測技術的普及與應用規模的擴大，亦衍生出諸多挑戰，包括網路連結穩定性、數據隱私保護、資源管理與能源效率提升、網路安全風險等，亟需透過技術創新與學術研究尋求有效解決方案。
                        WASN 2025 國際研討會 將匯聚全球學術界、產業界及政府機構的專家學者，針對無線、隨意及感測網路的前沿發展、關鍵技術及應用挑戰進行深入探討。
                        本研討會旨在促進跨領域的學術交流與技術合作，推動智慧網路、雲端計算及無所不在的智慧服務發展，並強化相關產業的技術研發與競爭力。透過本次研討會，我們期望激發更多創新思維與前瞻性研究，共同開創無線網路技術的新紀元。
                        </p>
                    </section>

                    <section className="section">
                        <p>指導單位：國家科學及技術委員會</p>
                        <p>主辦單位：國立臺灣大學資訊工程學系</p>
                        <p>協辦單位：中央研究院資訊科技創新研究中心、臺大IoX創新研究中心、國科會工程處工程科技推展中心、台灣雲端物聯網產業協會</p>
                        <p>主要贊助商：中華電信研究院</p>
                    </section>

                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Home;
